import type { ActionContext } from 'vuex'

import type { ActionClass, AppState } from '../../../models'

import { APP_CONSTS } from '../app.consts'

export class AddPlayedAnimationAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<AppState, any>, animationId: string): void {
    commit(APP_CONSTS.mutations.addPlayedAnimation, animationId)
  }
}
